import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import Page from '../Page';
import config from '../../config';

const NotFound = ({ message }) => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Page title="404: Not found">
      <Container maxWidth="lg">
        <Typography
          align="center"
          variant={mobileDevice ? 'h4' : 'h1'}
          color="textPrimary"
        >
          404: Page not found.
        </Typography>
        {message || (
          <Typography
            align="center"
            variant="subtitle2"
            color="textSecondary"
            paragraph
          >
            Sorry, the page isn't here. Please let us know what went wrong at{' '}
            <a href={`mailto:${config.supportContactAddress}`}>
              {config.supportContactAddress}
            </a>
            .
          </Typography>
        )}
        <Box mt={6} display="flex" justifyContent="center">
          <Button
            color="secondary"
            component={RouterLink}
            to="/"
            variant="outlined"
          >
            Back to home
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default NotFound;
